import _get from 'lodash.get';
import _set from 'lodash.set';

import { AwesomeEvent, ComponentAPI, Value } from '@philips-emr/tws-core';
import Changeable, { ChangeEventListener } from '@philips-emr/tws-core/lib/component/types/changeable';
import { isEnumValid } from '@philips-emr/tws-utils';

import { FieldVisibility } from '../../constants';

class FieldsetAPI extends ComponentAPI implements Changeable<Record<string, Value>> {

  /** @event */
  @AwesomeEvent
  onChange = new ChangeEventListener<Record<string, Value>>();

  getTitle(): string {
    return this.state.title;
  }

  setTitle(title: string): void {
    this.setState({ title });
  }

  getEntry(): string {
    return this.state.entry;
  }

  setEntry(entry: string): void {
    this.setState({ entry });
  }

  getClassName(): string {
    return this.state.className;
  }

  setClassName(className: string): void {
    this.setState({ className });
  }

  getData(): Record<string, Value> {
    return this.state.data;
  }

  setData(data: Record<string, Value>): void {
    this.setState({ data });
  }

  isVisible(): boolean {
    return this.state.visible;
  }

  setVisible(visible: boolean): void {
    this.setState({ visible });
  }

  setVisibility(visibility: FieldVisibility): void {
    if (!isEnumValid(FieldVisibility, visibility)) return;

    this.setState({ visibility });
  }

  getVisibility(): FieldVisibility {
    return this.state.visibility;
  }

  getValue(): Record<string, Value> {
    const data = this.getData();
    const entry = this.getEntry();

    return _get(data, entry) as Record<string, Value>;
  }

  setValue(value: Record<string, Value>): void {
    const data = this.getData();
    const entry = this.getEntry();

    const oldValue = _get(data, entry);
    _set(data, entry, value);

    this.setState({ data });
    this.onChange.fire({ entry, value, oldValue });
  }
}

export default FieldsetAPI;
